/** Maps Auth / profile failures to a reason the cashier can act on. */
export function mapAuthErrorMessage(raw: string): string {
  const text = raw.trim();
  const lower = text.toLowerCase();

  if (lower.includes('invalid login credentials')) {
    return 'Email o contraseña incorrectos. Si no recordás la clave, pedile al admin que la resetee en Equipo.';
  }
  if (lower.includes('email not confirmed')) {
    return 'El email no está confirmado. Pedile al admin que resetee la contraseña desde Equipo.';
  }
  if (lower.includes('usuario sin ficha') || lower.includes('sin organization')) {
    return 'Tu usuario no tiene ficha en la organización. Pedile al admin que te cree el acceso desde Equipo.';
  }
  if (lower.includes('too many requests') || lower.includes('rate limit')) {
    return 'Demasiados intentos. Esperá un momento e intentá de nuevo.';
  }
  if (lower.includes('supabase no inicializado')) {
    return 'El POS no está conectado a Supabase. Revisá la configuración del deploy.';
  }

  return text || 'Login falló';
}
